import React from 'react';

export const CenturionNetworkFAQs = () => {
  return <div>CenturionNetworkFAQs</div>;
};
